import FileTypeRenderer from '@/components/Grid/Renderers/FileTypeRenderer';
import FileLinkRenderer from '@/components/Grid/Renderers/FileLinkRenderer';
import ShowPropertyFileTypeOptions from '@/components/Grid/Renderers/ShowPropertyFileTypeOptions';
import riskhub from "@/services/Riskhub/Riskhub";

export const gridDefaultColDef = {
  resizable: true,
  sortable: true,
  filter: 'agSetColumnFilter',
  filterParams: {
    selectAllOnMiniFilter: false,
  },
};

function FormatToEuDate({ value }) {
  return riskhub.formatDate(value);
}

export const gridColumns = [
  {
    headerName: '',
    width: 100,
    minWidth: 100,
    maxWidth: 100,
    checkboxSelection: true,
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    cellRendererFramework: FileTypeRenderer,
  },
  {
    headerName: 'Name',
    field: 'filename',
    width: 300,
    minWidth: 300,
    cellRendererFramework: FileLinkRenderer,
    sort: 'desc',
  },
  {
    headerName: 'Type',
    field: 'type',
    width: 250,
    Width: 250,
    cellRendererFramework: ShowPropertyFileTypeOptions,
  },
  {
    headerName: 'RA Expiry Date',
    field: 'expiryDate',
    width: 130,
    minWidth: 130,
    cellRendererFramework: ShowPropertyFileTypeOptions,
  },
  {
    headerName: 'Issue Date',
    field: 'issueDate',
    width: 130,
    minWidth: 130,
    cellRendererFramework: ShowPropertyFileTypeOptions,
  },
  {
    headerName: 'Uploaded By',
    field: 'createdBy',
    width: 180,
    minWidth: 180,
  },
  {
    headerName: 'Uploaded Date',
    field: 'createdDate',
    width: 200,
    minWidth: 200,
    cellRenderer: FormatToEuDate,
  },
  {
    headerName: 'Size',
    field: 'size',
    width: 100,
    minWidth: 100,
  },
];
